import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Switch, Route } from 'react-router';
import { ThemeProvider } from 'emotion-theming';
import Layout from 'structure/layout';
import { Home, Store, Commission, Measurements, History, Faq, About, Product } from './pages';
import { getProducts } from 'service/products';
import log from 'util/log';
import globalStyles from './global-styles';
import theme from './theme';

globalStyles(theme);

const siteName = 'Creative Corsetry';

const GA_KEY = process.env.REACT_APP_GA_KEY;

const handleEvent = (event) => {
  window.gtag('event', event.event, {
    'event_category': event.category,
    'event_label': event.label,
    'value': event.value
  });
};

const handleTitleChanged = (title) => {
  window.gtag('config', GA_KEY, {
    'page_path': window.location.pathname,
    'page_title': title,
  });
}

const route = (routeProps, component, componentProps = {}) => {
  const Component = component;
  return <Route
    {...routeProps}
    render={(props) => <Component onSetTitle={handleTitleChanged} onEvent={handleEvent} siteName={siteName} {...props} {...componentProps} />}
  />;
};

class App extends React.Component {
  constructor() {
    super();
    log.info("App: constructor");
    // preload the product DB.
    getProducts().then(() => {
      log.info("App: getProducts resolved");
    });
  }

  render() {
    log.info("App: render");
    return (
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Layout onEvent={handleEvent}>
            <Switch>
              {route({ path: '/', exact: true }, Home)}
              {route({ path: '/store/(.*)-:product(\\d+)' }, Product)}
              {route({ path: '/store' }, Store)}
              {route({ path: '/commission' }, Commission)}
              {route({ path: '/measurements' }, Measurements)}
              {route({ path: '/history' }, History)}
              {route({ path: '/faq' }, Faq)}
              {route({ path: '/about' }, About)}

              {/* Fallback */}
              {route({}, Home)}
            </Switch>
          </Layout>
        </BrowserRouter>
      </ThemeProvider>
    );
  }
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js